export default "https://cdn-static.gokick.com/assets/9903bb00b89f5bdf744fe0cfa18ff86718068cd8/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";